/** @format */

import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import API from 'src/api/ApiDashboard'
import { useHistory } from 'react-router'
import useFormTable from 'src/hooks/useFormTable'
import { TablePage, Divider } from 'src/components'
import {
  _$,
  Editable,
  Button,
  Icon,
  Message,
  Dialog,
  Form,
  FormItem,
  Input,
  Tooltip
} from 'kpc-react'
import { MonitorSearch } from 'src/components'
import { request } from 'src/utils'
import { nameValidate } from 'src/config/validate'
import useGlobalData from 'src/hooks/useGlobalData'

const DashboardList: React.FC<{ className?: string }> = ({ className }) => {
  const [search, setSearch] = useState<string>('')
  const [createVisible, setCreateVisible] = useState<boolean>(false)
  const [createName, setCreateName] = useState<string>('')
  const createFormRef = useRef<any>()
  const history = useHistory()
  useGlobalData('productList')

  useEffect(() => {
    run()
  }, [search])

  const { run, result, total, pageState, loading } = useFormTable(
    API.ListDashboards,
    {
      params: { Query: search },
      manual: true
    },
    data => ({
      tableData: data?.dashboardList || [],
      totalCount: data?.totalCount || 0
    })
  )

  const tableScheme = {
    dashboardName: {
      title: _$('名称'),
      template: item => (
        <Editable
          value={item.dashboardName}
          onChange={(_c, value) => {
            updateName(item.dashboardId, value)
          }}
          validate={value => {
            return value && nameValidate.validate.test(value)
          }}
        >
          <span>{item.dashboardName}</span>
        </Editable>
      )
    },
    graphCount: _$('图表数据'),
    createdAt: _$('创建时间'),
    active: {
      title: _$('操作'),
      template: item => {
        const { dashboardId, dashboardName } = item
        return (
          <div className="ksc-space">
            <a
              onClick={event => {
                history.push(`/monitor/dashboard/detail/private/${item.dashboardId}`)
              }}
            >
              {_$('查看')}
            </a>
            <Divider />
            <Tooltip
              content={_$('确定删除？', { name: dashboardName })}
              confirm
              theme="light"
              trigger="click"
              onOk={async () => {
                deleteDashboard(dashboardId)
              }}
            >
              <a>{_$('删除')}</a>
            </Tooltip>
          </div>
        )
      }
    }
  }

  //  修改面板名称名称
  const updateName = async (id, value) => {
    const result = await request(`${API.ModifyDashboard}`, {
      method: 'POST',
      data: {
        DashboardId: id,
        DashboardName: value
      }
    })
    if (result.code === 'Success') {
      Message.success(result.message)
      run()
    } else {
      result?.message && Message.error(result.message)
    }
  }

  // 删除面板
  const deleteDashboard = async id => {
    const result = await request(`${API.DeleteDashboard}`, {
      method: 'POST',
      data: {
        DashboardId: id
      }
    })
    if (result.code === 'Success') {
      Message.success(result.message)
      run()
    } else {
      result?.message && Message.error(result.message)
    }
  }

  // 新建自定义Dashboard
  const createSubmit = async () => {
    const visible = await createFormRef.current.validate()
    if (visible) {
      const { code, message } = await request(`${API.CreateDashboard}`, {
        method: 'POST',
        data: {
          DashboardName: createName
        }
      })
      if (code === 'Success') {
        Message.success(message)
        setCreateVisible(false)
        run()
      } else {
        message && Message.error(message)
      }
    }
  }

  return (
    <div className={className}>
      <div className="header">
        <Button
          type="primary"
          onClick={() => {
            setCreateVisible(true)
          }}
        >
          <Icon className="ion-plus-round" />
          {_$('新建自定义Dashboard')}
        </Button>
        <MonitorSearch
          value={search}
          placeholder="输入面板名称"
          onChange={value => {
            setSearch(value)
          }}
        />
      </div>
      <div className="marginTop">
        <TablePage
          tableProps={{
            scheme: tableScheme,
            data: result,
            resizable: true,
            checkType: 'none'
          }}
          pageProps={{ total, ...pageState }}
          loading={loading}
          run={run}
        />
      </div>
      <Dialog
        width={500}
        value={createVisible}
        onClose={() => {
          setCreateName('')
          setCreateVisible(false)
        }}
        title={_$('新建自定义Dashboard')}
        mode="destroy"
        ok={createSubmit}
      >
        <Form starOnRequired ref={createFormRef}>
          <FormItem
            label={_$('名称')}
            value={createName}
            rules={{ required: true, userName: true }}
          >
            <Input value={createName} on$change-value={(_c, value) => setCreateName(value)} />
          </FormItem>
        </Form>
      </Dialog>
    </div>
  )
}

export default styled(DashboardList)`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`
